import short from 'short-uuid'
import { firestore, storage } from '../../firebase'
import { ref, uploadBytesResumable, getDownloadURL, listAll } from 'firebase/storage'
import {
  Timestamp,
  doc, getDoc, getDocs, setDoc, updateDoc,
  collection, collectionGroup, query, where,
  deleteDoc,
  // addDoc, endAt, orderBy, startAt, serverTimestamp,documentId
} from 'firebase/firestore'
import { Action } from '../actionTypes';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { trackExperienceCreated, trackMarkerCreated, trackAddToCart } from '../../utils/ga4Analytics';

// Helper function to get the correct user ID for cart operations
// This handles B2B account switching for admins
const getActiveUserId = (): string => {
  const isAdminMode = localStorage.getItem('isAdminMode') === 'true'
  const activeAccountId = localStorage.getItem('activeAccountId')
  const activeAccountType = localStorage.getItem('activeAccountType')
  
  let uid = localStorage.getItem('userId')
  
  // If admin is switched to a B2B account, use the active account ID
  if (isAdminMode && activeAccountId && activeAccountType === 'b2b') {
    uid = activeAccountId
  }
  
  return uid || ''
}

export const uploadBlob: any = (payload: any) => async (dispatch: any) => {
  //FYI this function does not dispatch a new state
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.CREATE_BLOB_INIT,
    })
    try {
      let url = payload.dirs.join('/')
      if (payload.setUser) {
        url = `usercontent/${uid}/${url}`
      }
      const storageRef = ref(storage, `${url}/${payload.filename}`)
      const uploadTask = uploadBytesResumable(storageRef, payload.blob)
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          dispatch({
            type: Action.CREATE_BLOB_SUCCESS,
            payload: {
              progress: progress,
              downloadURL: '',
              error: '',
            },
          })
        },
        (error) => {
          console.log(error)
          dispatch({
            type: Action.CREATE_BLOB_FAIL,
            payload: {
              progress: 0,
              downloadURL: '',
              error: 'Failed to upload blob!',
            },
          })
        },
        async () => {
          const downloadURL = await getDownloadURL(storageRef)
          dispatch({
            type: Action.CREATE_BLOB_SUCCESS,
            payload: {
              progress: 100,
              downloadURL: downloadURL,
              error: '',
            },
          })
          resolve(downloadURL)
          // generatePopup('success', 'Blob was created successfully!')
        }
      )
    } catch (error: any) {
      dispatch({
        type: Action.CREATE_BLOB_FAIL,
        payload: 'Failed to upload blob!',
      })
    }
  })
}

export const getBlobUrl: any = (payload: any) => async (dispatch: any) => {
  //FYI this function does not dispatch a new state
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_BLOB_URL_INIT,
    })
    try {
      let url = payload.dirs.join('/')
      if (payload.setUser) {
        url = `usercontent/${uid}/${url}`
      }
      const storageRef = ref(storage, `${url}/${payload.filename}`)
      const downloadURL = await getDownloadURL(storageRef)
      dispatch({
        type: Action.GET_BLOB_URL_SUCCESS,
        payload: downloadURL,
      })
      resolve(downloadURL)
      //generatePopup("success", "Blob was created successfully!");
    } catch (error: any) {
      console.log('FAILED TO GET URL');
      dispatch({
        type: Action.GET_BLOB_URL_FAIL,
        payload: 'Failed to get url!',
      })
      resolve(Action.GET_BLOB_URL_FAIL) //TODO: need to refactor the receiver code to listen for actionTypes.CREATE_BLOB_FAIL
    }
  })
}

export const copyFiles: any = (payload: any) => async (dispatch: any) => {
  //FYI this function does not dispatch a new state
  return new Promise(async (resolve, reject) => {
    dispatch({ type: Action.COPY_SCENE_INIT })
    try {
      const uid = localStorage.getItem('userId')
      const duplicateId = short.generate()

      // Duplicate Firebase document

      const sceneRef = doc(firestore, `users/${uid}/scenes/${payload.sceneId}`)
      const docSnapshot = await getDoc(sceneRef)
      const dupeData = { ...docSnapshot.data(), _id: duplicateId, isDuplicate: true }
      await dispatch(createCard(dupeData))

      // OMITTING FILE DUPLICATION
      // We currently have no operation to delete files from storage, so the original URL references will always work.
      // If the user uploads new assets to the duplicated scene, it'll create new files under the userContent/{user}/scenes/{dupeScene} folder.
      // Keep this code as a reference if we need to copy files in the future (Firebase does not have a copy API)

      // const sceneUrl  = `usercontent/${uid}/scenes/${payload.sceneId}`
      // listAll(ref(storage, sceneUrl)).then(res => {
      //   res.items.forEach(async (itemRef) => {
      //     const storageRef = ref(storage, `${sceneUrl}/${itemRef.name}`)
      //     const downloadURL = await getDownloadURL(storageRef)
      //     fetch(downloadURL).then(res => res.blob()).then(async (blob) => {
      //       const filename = `${duplicateId}/${storageRef.name}`
      //       await dispatch(uploadBlob({ blob: blob, filename: filename, dirs: ['dupes'], setUser: true }));
      //     });
      //   });
      // })

      dispatch({ type: Action.COPY_SCENE_SUCCESS, payload: dupeData })
      resolve(dupeData)
    } catch (error: any) {
      dispatch({ type: Action.COPY_SCENE_FAIL, payload: 'Failed to copy files!' })
      resolve(Action.COPY_SCENE_FAIL)
    }
  })
}

export const getAssetUrlList: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_ASSET_URL_LIST_INIT,
    })
    try {
      let url = payload.dirs.join('/')
      if (payload.setUser) {
        url = `usercontent/${uid}/${url}`
      }
      const storageRef = ref(storage, `${url}`)
      listAll(storageRef)
        .then((res) => {
          res.items.forEach((itemRef) => {
            // All the items under listRef.
            // console.log('itemRef', itemRef.name);
          });
          dispatch({
            type: Action.GET_ASSET_URL_LIST_SUCCESS,
            payload: res,
          })
          resolve(res.items);
        })
        .catch((error) => {
          console.log('FAILED TO GET URL');
          console.log(error);
          dispatch({
            type: Action.GET_ASSET_URL_LIST_FAIL,
            payload: 'Failed to get url!',
          })
          resolve(Action.GET_ASSET_URL_LIST_FAIL)
        });
      //generatePopup("success", "Blob was created successfully!");
    } catch (error: any) {
      console.log('FAILED TO GET URL');
      dispatch({
        type: Action.GET_ASSET_URL_LIST_FAIL,
        payload: 'Failed to get url!',
      })
      resolve(Action.GET_ASSET_URL_LIST_FAIL)
    }
  })
}

export const get3DScene: any = (payload: any) => async (dispatch: any) => {
  //FYI this function does not dispatch a new state
  const jsonUrl = await dispatch(
    getBlobUrl({
      filename: `${payload.sceneFileName}`,
      dirs: ['assets'],
      setUser: true,
    })
  );

  try {
    let response = await fetch(jsonUrl);
    const jsonFromFirebase = await response.json();
    return { responseType: 'success', projectJSON: jsonFromFirebase };
  } catch (error) {
    return { responseType: 'error', error: error };
  }
}

export const updateAsset: any = (payload: any) => async (dispatch: any) => {
  //TODO: This is duplicate code from 'updateCard', consider consolidation
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({ type: Action.POST_UPDATE_ASSET_INIT })
    try {
      if (!('_id' in payload)) { throw new Error('Asset id is not defined!') }
      const id = payload._id
      payload['updatedAt'] = new Date().getTime()

      const cardRef = doc(firestore, `users/${uid}/assets/${id}`)
      await updateDoc(cardRef, payload)
      dispatch({
        type: Action.POST_UPDATE_ASSET_SUCCESS,
        payload: payload,
      })
      resolve(payload)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.POST_UPDATE_ASSET_FAIL,
        payload: 'Failed to create asset!',
      })
    }
  })
}

export const updateCard: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.POST_UPDATE_CARD_INIT,
    })
    try {
      if (!('_id' in payload)) {
        throw new Error('Card id is not defined!')
      }
      const id = payload._id
      //delete payload._id
      payload['updatedAt'] = new Date().getTime()

      const cardRef = doc(firestore, `users/${uid}/scenes/${id}`)
      // let res = await updateDoc(cardRef, payload) //omitting "res" due to eslint warning
      await updateDoc(cardRef, payload)
      dispatch({
        type: Action.POST_UPDATE_CARD_SUCCESS,
        payload: payload,
      })
      //generatePopup('success', 'Card was created successfully!')
      resolve(payload)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.POST_UPDATE_CARD_FAIL,
        payload: 'Failed to create card!',
      })
    }
  })
}

export const updateMarker: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.POST_UPDATE_MARKER_INIT,
    })
    try {
      if (!('_id' in payload)) {
        throw new Error('Marker id is not defined!')
      }
      const id = payload._id
      //delete payload._id
      payload['updatedAt'] = new Date().getTime()

      const cardRef = doc(firestore, `users/${uid}/markers/${id}`)
      // let res = await updateDoc(cardRef, payload) //omitting "res" due to eslint warning
      await updateDoc(cardRef, payload)
      dispatch({
        type: Action.POST_UPDATE_MARKER_SUCCESS,
        payload: payload,
      })
      //generatePopup('success', 'Card was created successfully!')
      resolve(payload)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.POST_UPDATE_MARKER_FAIL,
        payload: 'Failed to create markre!',
      })
    }
  })
}

export const createAsset: any = (payload: any) => async (dispatch: any) => {
  //TODO: This is duplicate code from 'createCard', consider consolidation
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.POST_CREATE_ASSET_INIT,
    })
    try {
      let id = short.generate()
      if ('_id' in payload && payload._id) {id = payload._id}

      const cardRef = doc(firestore, `users/${uid}/assets/${id}`)
      payload['uid'] = uid
      payload['_id'] = id
      payload['updatedAt'] = new Date().getTime()
      payload['createdAt'] = new Date().getTime()
      await setDoc(cardRef, payload)
      dispatch({
        type: Action.POST_CREATE_ASSET_SUCCESS,
        payload: payload,
      })
      resolve(payload)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.POST_CREATE_ASSET_FAIL,
        payload: 'Failed to create card!',
      })
    }
  })
}

export const createCard: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.POST_CREATE_CARD_INIT,
    })
    try {
      let id = short.generate()

      if ('_id' in payload && payload._id) {
        id = payload._id
      }

      const cardRef = doc(firestore, `users/${uid}/scenes/${id}`)
      payload['uid'] = uid
      payload['_id'] = id
      payload['updatedAt'] = new Date().getTime()
      payload['createdAt'] = new Date().getTime()
      payload['scanCount'] = 0
      //console.log('payload', payload)
      await setDoc(cardRef, payload)
      dispatch({
        type: Action.POST_CREATE_CARD_SUCCESS,
        payload: payload,
      })
      
      // Track experience creation in GA4
      try {
        // Get current user data from state - this would need to be passed from the component
        // For now, we'll create the user object from available data
        const userEmail = localStorage.getItem('userEmail');
        if (userEmail && uid) {
          const user = { protected: { email: userEmail }, uid: uid };
          trackExperienceCreated(user, id, payload.name || 'Unnamed Experience', null);
        }
      } catch (error) {
        console.error('Error tracking experience creation in GA4:', error);
      }
      
      //generatePopup('success', 'Card was created successfully!')
      resolve(payload)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.POST_CREATE_CARD_FAIL,
        payload: 'Failed to create card!',
      })
    }
  })
}

export const createMarker: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.POST_CREATE_MARKER_INIT,
    })
    try {
      let id = short.generate()

      if ('_id' in payload && payload._id) {
        id = payload._id
      }

      const cardRef = doc(firestore, `users/${uid}/markers/${id}`)
      payload['uid'] = uid
      payload['_id'] = id
      payload['updatedAt'] = new Date().getTime()
      payload['createdAt'] = new Date().getTime()
      //console.log('payload', payload)
      await setDoc(cardRef, payload)
      dispatch({
        type: Action.POST_CREATE_MARKER_SUCCESS,
        payload: payload,
      })
      
      // Track marker creation in GA4
      try {
        const userEmail = localStorage.getItem('userEmail');
        if (userEmail && uid) {
          const user = { protected: { email: userEmail }, uid: uid };
          trackMarkerCreated(user, id, payload.name || 'Unnamed Marker', null);
        }
      } catch (error) {
        console.error('Error tracking marker creation in GA4:', error);
      }
      
      //generatePopup('success', 'Card was created successfully!')
      resolve(payload)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.POST_CREATE_MARKER_FAIL,
        payload: 'Failed to create marker!',
      })
    }
  })
}

export const addToCart: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = getActiveUserId()
    
    console.log('addToCart - Debug Info:', {
      isAdminMode: localStorage.getItem('isAdminMode') === 'true',
      activeAccountId: localStorage.getItem('activeAccountId'),
      activeAccountType: localStorage.getItem('activeAccountType'),
      localStorageUserId: localStorage.getItem('userId'),
      finalUid: uid,
      payload
    })
    
    dispatch({
      type: Action.POST_ADD_TO_CART_INIT,
    })
    try {
      let id = payload?.variant_id
      let sceneId = payload?.scene_id

      if (!id) {
        throw new Error('Variant id is not defined!')
      }

      if (!sceneId) {
        throw new Error('Scene id is not defined!')
      }

      const cartRef = doc(firestore, `users/${uid}/cart/${sceneId}-${id}`)
      payload['uid'] = uid
      payload['updatedAt'] = new Date().getTime()
      payload['createdAt'] = new Date().getTime()
      console.log('addToCart - Adding to cart:', { uid, sceneId, id, cartPath: `users/${uid}/cart/${sceneId}-${id}` })
      await setDoc(cartRef, payload)
      dispatch({
        type: Action.POST_ADD_TO_CART_SUCCESS,
        payload: payload,
      })
      
      // Track add to cart in GA4
      try {
        const userEmail = localStorage.getItem('userEmail');
        if (userEmail) {
          const user = { protected: { email: userEmail }, uid: uid };
          trackAddToCart(
            user,
            payload.name || 'Unknown Product',
            payload.price || 0,
            payload.variant_id || id,
            sceneId,
            payload.marker_id,
            null
          );
        }
      } catch (error) {
        console.error('Error tracking add to cart in GA4:', error);
      }
      
      console.log('addToCart - Success:', payload)
      resolve(payload)
    } catch (error: any) {
      console.error('addToCart - Error:', error)
      console.log(error)
      dispatch({
        type: Action.POST_ADD_TO_CART_FAIL,
        payload: 'Failed to create cart item!',
      })
    }
  })
}

export const removeFromCart: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = getActiveUserId()
    
    dispatch({
      type: Action.POST_REMOVE_FROM_CART_INIT,
    })
    try {
      let id = payload?.variant_id.toString()
      let sceneId = payload?.scene_id

      if (!id) {
        throw new Error('Variant id is not defined!')
      }

      if (!sceneId) {
        throw new Error('Scene id is not defined!')
      }

      const cartRef = doc(firestore, `users/${uid}/cart/${sceneId}-${id}`)
      // const ref = await deleteDoc(cartRef)
      await deleteDoc(cartRef)
      dispatch({
        type: Action.POST_REMOVE_FROM_CART_SUCCESS,
        payload: id,
      })
      //generatePopup('success', 'Card was created successfully!')
      resolve(payload)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.POST_REMOVE_FROM_CART_FAIL,
        payload: 'Failed to create cart item!',
      })
    }
  })
}

export const getCart: any = () => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = getActiveUserId()
    
    dispatch({ type: Action.GET_CART_INIT })
    try {
      const querySnapshot = await getDocs(collection(firestore, `users/${uid}/cart`))
      const res = querySnapshot.docs.map(doc => doc.data())
      dispatch({
        type: Action.GET_CART_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_CART_FAIL,
        payload: 'Failed to get cart!',
      })
    }
  })
}

export const getAssets: any = () => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({ type: Action.GET_ALL_ASSETS_INIT })
    try {
      const querySnapshot = await getDocs(collection(firestore, `users/${uid}/assets`))
      const res = querySnapshot.docs.map((doc) => {
        return doc.data()
      })
      dispatch({
        type: Action.GET_ALL_ASSETS_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ALL_ASSETS_FAIL,
        payload: 'Failed to get assets!',
      })
    }
  })
}

export const getCards: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_ALL_CARD_INIT,
    })
    try {
      // let plimit = payload?.itemsPerPage ? payload?.itemsPerPage : 100
      // let page = payload?.currentPage ? payload?.currentPage : 1
      // let offset = (page - 1) * plimit
      // console.log(plimit)
      // console.log(page)
      // console.log(offset)
      // console.log(offset + plimit)

      const cardsRef = collection(firestore, `users/${uid}/scenes`)
      const q = query(cardsRef, where('isDeleted', '==', false))
      const querySnapshot = await getDocs(q)

      const res = querySnapshot.docs.map((doc) => {
        return doc.data()
      })
      dispatch({
        type: Action.GET_ALL_CARD_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ALL_CARD_FAIL,
        payload: 'Failed to get scenes!',
      })
    }
  })
}

export const getMarkers: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_ALL_MARKER_INIT,
    })
    try {
      // let plimit = payload?.itemsPerPage ? payload?.itemsPerPage : 100
      // let page = payload?.currentPage ? payload?.currentPage : 1
      // let offset = (page - 1) * plimit
      // console.log(plimit)
      // console.log(page)
      // console.log(offset)
      // console.log(offset + plimit)

      const markersRef = collection(firestore, `users/${uid}/markers`)
      //const q = query(markersRef, where('isDeleted', '==', false))
      const querySnapshot = await getDocs(markersRef)

      const res = querySnapshot.docs.map((doc) => {
        return doc.data()
      })
      dispatch({
        type: Action.GET_ALL_MARKER_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ALL_MARKER_FAIL,
        payload: 'Failed to get markers!',
      })
    }
  })
}

export const getOrders: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_ALL_ORDERS_INIT,
    })
    try {
      // let plimit = payload?.itemsPerPage ? payload?.itemsPerPage : 100 //omitting due to eslint warning
      // let page = payload?.currentPage ? payload?.currentPage : 1 //omitting due to eslint warning
      // let offset = (page - 1) * plimit //omitting due to eslint warning

      //console.log(plimit)
      //console.log(page)
      //console.log(offset)
      //console.log(offset + plimit)
      const ordersRef = collection(firestore, `users/${uid}/orders`)
      const querySnapshot = await getDocs(ordersRef)

      const res = querySnapshot.docs.map((doc) => {
        return doc.data()
      })
      dispatch({
        type: Action.GET_ALL_ORDERS_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ALL_ORDERS_FAIL,
        payload: 'Failed to get orders!',
      })
    }
  })
}

export const getDeletedCards: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_ALL_DELETE_CARD_INIT,
    })
    try {
      // let plimit = payload?.itemsPerPage ? payload?.itemsPerPage : 100
      // let page = payload?.currentPage ? payload?.currentPage : 1
      // let offset = (page - 1) * plimit
      // console.log(plimit)
      // console.log(page)
      // console.log(offset)
      // console.log(offset + plimit)

      const cardsRef = collection(firestore, `users/${uid}/scenes`)
      const q = query(cardsRef, where('isDeleted', '==', true))
      const querySnapshot = await getDocs(q)

      const res = querySnapshot.docs.map((doc) => {
        return doc.data()
      })
      dispatch({
        type: Action.GET_ALL_DELETE_CARD_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ALL_DELETE_CARD_FAIL,
        payload: 'Failed to get scenes!',
      })
    }
  })
}

export const getDeletedMarkers: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_ALL_DELETE_MARKER_INIT,
    })
    try {
      // let plimit = payload?.itemsPerPage ? payload?.itemsPerPage : 100
      // let page = payload?.currentPage ? payload?.currentPage : 1
      // let offset = (page - 1) * plimit
      // console.log(plimit)
      // console.log(page)
      // console.log(offset)
      // console.log(offset + plimit)

      const cardsRef = collection(firestore, `users/${uid}/markers`)
      const q = query(cardsRef, where('isDeleted', '==', true))
      const querySnapshot = await getDocs(q)

      const res = querySnapshot.docs.map((doc) => {
        return doc.data()
      })
      dispatch({
        type: Action.GET_ALL_DELETE_MARKER_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ALL_DELETE_MARKER_FAIL,
        payload: 'Failed to get markers!',
      })
    }
  })
}

export const clearCardState: any = () => (dispatch: any) => {
  dispatch({
    type: Action.CLEAR_CARD_STATE,
  })
}

export const getCard: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    // const token: any = localStorage.getItem("userId") //omitting due to eslint warning
    dispatch({
      type: Action.GET_ONE_CARD_INIT,
    })
    try {
      if (payload?.id) {
        const cardsRef = collectionGroup(firestore, `scenes`)
        const q = query(cardsRef, where('_id', '==', payload.id))
        const querySnapshot = await getDocs(q)

        const res = querySnapshot.docs.map((doc) => ({
          _id: doc.id,
          ...doc.data(),
        }))

        dispatch({
          type: Action.GET_ONE_CARD_SUCCESS,
          payload: res ? res[0] : {},
        })
        resolve(res ? res[0] : {})
      } else {
        const sessid = short.generate()
        payload['_id'] = sessid
        dispatch({
          type: Action.GET_ONE_CARD_SUCCESS,
          payload: payload,
        })
        resolve(payload)
      }
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ONE_CARD_FAIL,
        payload: 'Failed to get card!',
      })
      reject(error)
    }
  })
}

export const getMultiCard: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    // const token: any = localStorage.getItem("userId") //omitting due to eslint warning
    dispatch({
      type: Action.GET_MULTI_CARD_INIT,
    })
    try {
      if (payload?.ids) {

        const cardsRef = collectionGroup(firestore, `scenes`)
        const q = query(cardsRef, where('_id', 'in', payload.ids))
        const querySnapshot = await getDocs(q)


        const res = querySnapshot.docs.map((doc) => ({
          _id: doc.id,
          ...doc.data(),
        }))

        let sorted:any = []
        payload?.ids.forEach((id:any, index:number) => {
          let found:any = {}
          found = res.find((item:any) => item._id === id)
          if (found){
            sorted.push(found)
          }
        })

        dispatch({
          type: Action.GET_MULTI_CARD_SUCCESS,
          payload: sorted,
        })
        resolve(res || [])
      } else {
        throw new Error('No ids provided')
      }
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_MULTI_CARD_FAIL,
        payload: 'Failed to get cards!',
      })
      reject(error)
    }
  })
}

export const getMultiMarker: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    // const token: any = localStorage.getItem("userId") //omitting due to eslint warning
    dispatch({
      type: Action.GET_MULTI_MARKER_INIT,
    })
    try {
      console.log('markerIds', payload)
      if (payload?.ids) {

        const markersRef = collectionGroup(firestore, `markers`)
        const q = query(markersRef, where('_id', 'in', payload?.ids))
        const querySnapshot = await getDocs(q)
        const res = querySnapshot.docs.map((doc) => ({
          _id: doc.id,
          ...doc.data(),
        }))
        console.log('res', res)

        dispatch({
          type: Action.GET_MULTI_MARKER_SUCCESS,
          payload: res,
        })
        resolve(res || [])
      } else {
        throw new Error('No ids provided')
      }
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_MULTI_MARKER_FAIL,
        payload: 'Failed to get markers!',
      })
      reject(error)
    }
  })
}

export const getMarker: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    // const token: any = localStorage.getItem("userId") //omitting due to eslint warning
    dispatch({
      type: Action.GET_ONE_MARKER_INIT,
    })
    try {
      if (payload?.id) {
        const cardsRef = collectionGroup(firestore, `markers`)
        const q = query(cardsRef, where('_id', '==', payload.id))
        const querySnapshot = await getDocs(q)

        const res = querySnapshot.docs.map((doc) => ({
          _id: doc.id,
          ...doc.data(),
        }))

        dispatch({
          type: Action.GET_ONE_MARKER_SUCCESS,
          payload: res ? res[0] : {},
        })
        resolve(res)
      } else {
        const sessid = short.generate()
        payload['_id'] = sessid
        dispatch({
          type: Action.GET_ONE_MARKER_SUCCESS,
          payload: payload,
        })
        resolve(payload)
      }
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ONE_MARKER_FAIL,
        payload: 'Failed to get marker!',
      })
      reject(error)
    }
  })
}

export const updateAnalytics: any = (jsonData: any, id: string) => async () => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem("userId")
    const currentDate = getCurrentDate()
    try {
      const cardRef = doc(firestore, `users/${uid}/cards/${id}`)
      const analyticsCollectionRef = collection(cardRef, 'analytics');
      const analyticsDocRef = doc(analyticsCollectionRef, currentDate);
      const analyticsDataWithTimestamp = { ...jsonData };

      // Check if the document exists
      const docSnapshot = await getDoc(analyticsDocRef);
      const existingData = docSnapshot.exists() ? docSnapshot.data() : {};

      // Increment existing values in the JSON
      for (const key in analyticsDataWithTimestamp) {
        if (typeof analyticsDataWithTimestamp[key] === 'object') {
          for (const subKey in analyticsDataWithTimestamp[key]) {
            existingData[key] = {
              ...existingData[key],
              [subKey]: (existingData[key]?.[subKey] || 0) + analyticsDataWithTimestamp[key][subKey],
            };
          }
        } else {
          existingData[key] = (existingData[key] || 0) + analyticsDataWithTimestamp[key];
        }
      }
      existingData.date = Timestamp.fromDate(new Date())
      if (!docSnapshot.exists()) {
        await setDoc(analyticsDocRef, existingData);
      } else {
        await updateDoc(analyticsDocRef, existingData);
      }

      resolve(existingData);
    } catch (error) {
      console.error('Error updating document:', error);
      reject(error);
    }
  });
};

export const getCardAnalytics: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch({
      type: Action.GET_CARD_ANALYTICS_INIT,
    })

    try {
      if (payload.id) {
        const cardsRef = collectionGroup(firestore, 'scenes')
        const q = query(cardsRef, where('_id', '==', payload.id))
        const querySnapshot = await getDocs(q)

        if (querySnapshot.docs.length > 0) {
          const doc = querySnapshot.docs[0]
          const analyticsRef = collection(doc.ref, 'analytics')

          const startDate = Timestamp.fromDate(new Date(payload.startDate));
          const endDate = Timestamp.fromDate(new Date(payload.endDate));
          const analyticsQuery = query(analyticsRef, where('timestamp', '>=', startDate), where('timestamp', '<=', endDate));

          const filteredAnalyticsQuerySnapshot = await getDocs(analyticsQuery)

          const analyticsData: Record<string, any[]> = {}
          filteredAnalyticsQuerySnapshot.docs.forEach((analyticsDoc) => {
            const collectionName = analyticsDoc.id
            const data = analyticsDoc.data()
            delete data['analyticsId']
            analyticsData[collectionName] = [data]
          })

          const cardData = {
            _id: doc.id,
            // ...doc.data(),
            analytics: analyticsData,
          }

          dispatch({
            type: Action.GET_CARD_ANALYTICS_SUCCESS,
            payload: cardData,
          })

          resolve(cardData)
        } else {
          // Handle case when no document is found
          dispatch({
            type: Action.GET_CARD_ANALYTICS_FAIL,
            payload: 'Card not found!',
          })

          resolve(null)
        }
      } else {
        // Handle case when payload is falsy
        const sessid = short.generate()
        payload = { _id: sessid }

        dispatch({
          type: Action.GET_CARD_ANALYTICS_SUCCESS,
          payload: payload,
        })

        resolve(payload)
      }
    } catch (error: any) {
      console.error(error)
      dispatch({
        type: Action.GET_CARD_ANALYTICS_FAIL,
        payload: 'Failed to get card analytics!',
      })

      resolve(null)
    }
  })
}

export const getTodayAnalytics: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch({
      type: Action.GET_TODAY_ANALYTICS_INIT,
    })

    try {
          const uid = localStorage.getItem('userId')
          const analyticsRef = collection(firestore,`users/${uid}/analytics`)

          const analyticsQuery = query(analyticsRef, where(payload.type, '==', payload.id), where('timestamp', '>=', payload.startDate));
          const querySnapshot = await getDocs(analyticsQuery);

          let res = {}
          querySnapshot.docs.forEach((doc:any) => {
            let docd = doc.data()
            if (docd?.ip in res){
              res[docd?.ip].push(docd)
            }else{
              res[docd?.ip] = [docd]
            }
          })

          dispatch({
            type: Action.GET_TODAY_ANALYTICS_SUCCESS,
            payload: res,
          })

          resolve(res)

    } catch (error: any) {
      console.error(error)
      dispatch({
        type: Action.GET_TODAY_ANALYTICS_FAIL,
        payload: 'Failed to get card analytics!',
      })

      resolve(null)
    }
  })
}

export const deleteCard: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.CARD_DELETE_INIT,
    })
    try {
      const cardRef = doc(firestore, `users/${uid}/scenes/${payload}`)
      const ref = await updateDoc(cardRef, { isDeleted: true })
      dispatch({
        type: Action.CARD_DELETE_SUCCESS,
        payload: ref,
      })
      resolve(ref)
    } catch (error: any) {
      dispatch({
        type: Action.CARD_DELETE_FAIL,
        payload: 'Failed to delete card!',
      })
    }
  })
}

export const deleteMarker: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.MARKER_DELETE_INIT,
    })
    try {
      const cardRef = doc(firestore, `users/${uid}/markers/${payload}`)
      const ref = await updateDoc(cardRef, { isDeleted: true })
      dispatch({
        type: Action.MARKER_DELETE_SUCCESS,
        payload: ref,
      })
      resolve(ref)
    } catch (error: any) {
      dispatch({
        type: Action.MARKER_DELETE_FAIL,
        payload: 'Failed to delete marker!',
      })
    }
  })
}

export const permanentlyDeleteMarker: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.MARKER_PERMANENTLY_DELETE_INIT,
    })
    try {
      const cardRef = doc(firestore, `users/${uid}/markers/${payload}`)
      const ref = await deleteDoc(cardRef)
      dispatch({
        type: Action.MARKER_PERMANENTLY_DELETE_SUCCESS,
        payload: ref,
      })
      resolve(ref)
    } catch (error: any) {
      console.log('error deleting doc')
      dispatch({
        type: Action.MARKER_PERMANENTLY_DELETE_FAIL,
        payload: 'Failed to delete marker!',
      })
    }
  })
}

export const restoreCard: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.CARD_RESTORE_INIT,
    })
    try {
      const cardRef = doc(firestore, `users/${uid}/scenes/${payload}`)
      const ref = await updateDoc(cardRef, { isDeleted: false })
      dispatch({
        type: Action.CARD_RESTORE_SUCCESS,
        payload: ref,
      })
      resolve(ref)
    } catch (error: any) {
      dispatch({
        type: Action.CARD_RESTORE_FAIL,
        payload: 'Failed to restore card!',
      })
    }
  })
}

export const getActiveCards: any = (payload: any) => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    const uid = localStorage.getItem('userId')
    dispatch({
      type: Action.GET_ACTIVE_CARD_INIT,
    })
    try {
      let plimit = payload?.itemsPerPage ? payload?.itemsPerPage : 100
      let page = payload?.currentPage ? payload?.currentPage : 1
      let offset = (page - 1) * plimit

      console.log(plimit)
      console.log(page)
      console.log(offset)
      console.log(offset + plimit)
      const cardsRef = collection(firestore, `users/${uid}/scenes`)
      const q = query(cardsRef, where('protected.isActive', '==', true), where('isDeleted', '==', false))
      const querySnapshot = await getDocs(q)

      const res = querySnapshot.docs.map((doc) => {
        return doc.data()
      })
      dispatch({
        type: Action.GET_ACTIVE_CARD_SUCCESS,
        payload: res,
      })
      resolve(res)
    } catch (error: any) {
      console.log(error)
      dispatch({
        type: Action.GET_ACTIVE_CARD_FAIL,
        payload: 'Failed to get scenes!',
      })
    }
  })
}

export const shareMarker: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch({
      type: Action.SHARE_MARKER_INIT,
    })
    try {
      const functions = getFunctions()
      const shareMarkerFunction = httpsCallable(functions, 'shareMarker')
      
      const result: any = await shareMarkerFunction(payload)
      
      dispatch({
        type: Action.SHARE_MARKER_SUCCESS,
        payload: result.data,
      })
      
      resolve(result.data)
    } catch (error: any) {
      console.error('Error sharing marker:', error)
      dispatch({
        type: Action.SHARE_MARKER_FAIL,
        payload: error.message || 'Failed to share marker',
      })
      reject(error)
    }
  })
}

export const getSharedMarkers: any = () => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch({
      type: Action.GET_SHARED_MARKERS_INIT,
    })
    try {
      const functions = getFunctions()
      const getSharedMarkersFunction = httpsCallable(functions, 'getSharedMarkers')
      
      const result: any = await getSharedMarkersFunction()
      
      dispatch({
        type: Action.GET_SHARED_MARKERS_SUCCESS,
        payload: result.data.markers,
      })
      
      resolve(result.data.markers)
    } catch (error: any) {
      console.error('Error getting shared markers:', error)
      dispatch({
        type: Action.GET_SHARED_MARKERS_FAIL,
        payload: error.message || 'Failed to get shared markers',
      })
      reject(error)
    }
  })
}

export const getMarkerAnalytics: any = (payload: any) => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch({
      type: Action.GET_MARKER_ANALYTICS_INIT,
    })
    try {
      const functions = getFunctions()
      const getMarkerAnalyticsFunction = httpsCallable(functions, 'getMarkerAnalytics')
      
      const result: any = await getMarkerAnalyticsFunction(payload)
      
      dispatch({
        type: Action.GET_MARKER_ANALYTICS_SUCCESS,
        payload: result.data,
      })
      
      resolve(result.data)
    } catch (error: any) {
      console.error('Error getting marker analytics:', error)
      dispatch({
        type: Action.GET_MARKER_ANALYTICS_FAIL,
        payload: error.message || 'Failed to get marker analytics',
      })
      reject(error)
    }
  })
}

export const getShareableAccounts: any = () => async (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    dispatch({
      type: Action.GET_SHAREABLE_ACCOUNTS_INIT,
    })
    try {
      const functions = getFunctions()
      const getShareableAccountsFunction = httpsCallable(functions, 'getShareableAccounts')
      
      const result: any = await getShareableAccountsFunction()
      
      dispatch({
        type: Action.GET_SHAREABLE_ACCOUNTS_SUCCESS,
        payload: result.data.accounts,
      })
      
      resolve(result.data.accounts)
    } catch (error: any) {
      console.error('Error getting shareable accounts:', error)
      dispatch({
        type: Action.GET_SHAREABLE_ACCOUNTS_FAIL,
        payload: error.message || 'Failed to get shareable accounts',
      })
      reject(error)
    }
  })
}

function getCurrentDate() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const year = now.getFullYear();
  return `${month}-${day}-${year}`;
}